import React, { useState, useMemo } from "react";
import { Table } from "semantic-ui-react";
import { shape, string, arrayOf, bool, func, instanceOf } from "prop-types";
import { I18nShape } from "shared/shapes/i18n.shape";
import { renderTableHeader, renderTableBody } from "./TablePartsRenderers";
import { DocumentSignaturesResource } from "../../../actions/documentsActions";
import { signatureColumns } from "../../../selectors/documentExports";

import "./documentExport.scss";

const SignaturesTab = ({
  i18n,
  list,
  isLoading,
  loadData,
  documentSignaturesResource
}) => {
  const [filters, setFilters] = useState();

  const applyFilter = (name, vals) => {
    setFilters({ ...filters, [name]: vals.value });
  };

  const filterList = useMemo(() => {
    if (!filters) return list;
    let data = [...list];

    Object.keys(filters).forEach(key => {
      const value = filters[key];
      if (value) data = data.filter(x => x[key] === value);
    });
    return data;
  }, [filters, list]);

  const handlers = {
    handleSubmit: model => {
      return documentSignaturesResource.save(model).then(() => {
        loadData();
      });
    },
    handleDelete: id => {
      return documentSignaturesResource.remove(id).then(() => {
        loadData();
      });
    },
    handlePreview: () => {},
    handleDuplicate: () => {},
    handleDuplicateAll: () => {}
  };

  return (
    <Table>
      {renderTableHeader({
        i18n,
        columns: signatureColumns,
        list,
        handlers,
        applyFilter,
        title: "documentsExport.menu.signatures.title",
        dialog: "signature"
      })}
      {renderTableBody({
        i18n,
        columns: signatureColumns,
        list: filterList,
        isLoading,
        handlers,
        dialog: "signature"
      })}
    </Table>
  );
};

SignaturesTab.propTypes = {
  i18n: I18nShape.isRequired,
  list: arrayOf(
    shape({
      name: string
    })
  ),
  isLoading: bool.isRequired,
  documentSignaturesResource: instanceOf(DocumentSignaturesResource).isRequired,
  loadData: func.isRequired
};

SignaturesTab.defaultProps = {
  list: []
};

export default SignaturesTab;
